import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import applyReducer from './applyReducer';
import passwordConstants from '../constants/passwordConstants';
import { checkRules } from '../utils/passwordRules';
const initState = {
  rules: {
    length: false,
    upper: false,
    lower: false,
    symbol: false
  }
};
const checkPasswordRules = (state, action) => {
  const rules = checkRules(action.password);
  return _objectSpread(_objectSpread({}, state), {}, {
    rules
  });
};
const resetPasswordRules = state => _objectSpread(_objectSpread({}, state), {}, {
  rules: _objectSpread({}, initState.rules)
});
const reducers = {
  [passwordConstants.PASSWORD_RULES_CHECK]: checkPasswordRules,
  [passwordConstants.PASSWORD_RULES_RESET]: resetPasswordRules
};
export default applyReducer(reducers, initState);